"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseModule = _interopRequireDefault(require("../styles/base.module.css"));

var _formFiledModule = _interopRequireDefault(require("../styles/form-filed.module.css"));

var _loginModule = _interopRequireDefault(require("../styles/login.module.css"));

var _Icons = require("./Icons");

var _Loader = require("./Loader");

var _constant = require("./constant");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ForgotPass =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ForgotPass, _React$Component);

  function ForgotPass(props) {
    var _this;

    _classCallCheck(this, ForgotPass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForgotPass).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "requestReset", function (e) {
      e.preventDefault();

      _this.setState({
        requesting: true
      });

      var formData = new FormData(e.target);
      fetch("".concat(_constant.API_ROOT, "forgotPass.php"), {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      }).then(_constant.checkStatus).then(_constant.parseJSON).then(function (data) {
        if (data.status) {
          _this.setState({
            requesting: false,
            success: true
          });
        } else {
          _this.setState({
            requesting: false,
            error: true
          });
        }
      }).catch(function (err) {
        return console.log(err);
      });
    });

    _this.state = {
      error: false,
      requesting: false,
      success: false
    };
    return _this;
  }

  _createClass(ForgotPass, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          error = _this$state.error,
          requesting = _this$state.requesting,
          success = _this$state.success;

      if (success) {
        return _react.default.createElement("div", {
          className: _baseModule.default.container
        }, _react.default.createElement("div", {
          className: _loginModule.default.forgotSuccess
        }, _react.default.createElement("div", null, _react.default.createElement(_Icons.GreenCircularTick, {
          width: "2rem"
        }), "Reset email sent"), _react.default.createElement("button", {
          className: "".concat(_formFiledModule.default.button),
          onClick: this.props.back
        }, "Login")));
      }

      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: _baseModule.default.backButton,
        onClick: this.props.back
      }, _react.default.createElement(_Icons.BackArrow, {
        width: "0.875rem"
      }), _react.default.createElement("span", null, "Back")), _react.default.createElement("form", {
        className: _baseModule.default.container,
        onSubmit: this.requestReset
      }, error ? _react.default.createElement("span", {
        className: _loginModule.default.errorBlock
      }, _react.default.createElement(_Icons.CrossInsideCircle, {
        width: "1rem"
      }), _react.default.createElement("span", null, "Incorrect information. Email not registered")) : "", _react.default.createElement("div", {
        className: _formFiledModule.default.label
      }, "Please enter your registered email address."), _react.default.createElement("input", {
        type: "email",
        name: "email",
        placeholder: "Type here...",
        className: _formFiledModule.default.input,
        required: true
      }), _react.default.createElement("button", {
        type: "submit",
        className: "".concat(_formFiledModule.default.button, " ").concat(_formFiledModule.default.primary, " ").concat(_formFiledModule.default.block),
        disabled: requesting
      }, requesting ? _react.default.createElement(_Loader.ButtonLoader, null) : "Request Reset")));
    }
  }]);

  return ForgotPass;
}(_react.default.Component);

var _default = ForgotPass;
exports.default = _default;